import { List, Map, Set } from 'immutable';
import shortid from 'shortid';

import * as constants from './../constants';

const initialState = Map({
  browsers: {},
  recent_configs: List(),
  saved_configs: List(),
  url: '',
  realDevicesStarred: Set(),
});

const addMissingId = (config) => {
  if (!config.id) {
    return Map({ ...config, id: shortid.generate() });
  }

  return Map(config);
};

/**
 * Undoes the adding/removal of a star if there's an action FAILURE or CANCEL
 * @param {Immutable.Set} realDevicesStarred - current list of starred real devices
 * @param {{ added: DeviceDescriptor, removed: DeviceDescriptor }}
 *   added/removed device upon the REQUEST of this action; only one of these should be present
 * @returns {Immutable.Set} real devices with/without the device that was unsucessfully
 *   added/removed
 */
const undoStar = (realDevicesStarred, { added, removed }) => (
  added ? realDevicesStarred.delete(added.get('compositeId')) : realDevicesStarred.add(removed.get('compositeId'))
);

const metadataReducer = (state = initialState, { type, payload, meta }) => {
  switch (type) {
    case constants.METADATA_GET.SUCCESS: {
      const metadata = payload.items.reduce((result, { key, value }) => (
        { [key]: value, ...result }
      ), {});

      // Api will return { value: { url: "http://..." } } ¯\_(ツ)_/¯
      const url = (metadata.url && metadata.url.url) ? metadata.url.url : metadata.url;

      return state.merge({
        url: url || '',
        recent_configs: metadata.recent_configs ?
          List(metadata.recent_configs.map(addMissingId)) : List(),
        saved_configs: metadata.saved_configs ? List(metadata.saved_configs) : List(),
        realDevicesStarred: metadata.real_devices_starred_by_composite_id ?
          Set(metadata.real_devices_starred_by_composite_id) :
          Set(),
      });
    }
    case constants.OPTIONS_GET.SUCCESS:
      return state.set('browsers', payload);
    case constants.RECENT_CONFIGS_PUT.SUCCESS: {
      if (!payload.item) return state;

      let recents = List(payload.item.value);
      recents = recents.map((config) => Map(config));
      return state.set('recent_configs', recents);
    }
    case constants.SAVED_CONFIGS_PUT.SUCCESS: {
      if (!payload.item) return state;

      let saved = List(payload.item.value);
      saved = saved.map((config) => Map(config));
      return state.set('saved_configs', saved);
    }
    case constants.UPDATE_STARRED_REAL_DEVICES.REQUEST: {
      return state.set('realDevicesStarred', payload);
    }
    case constants.UPDATE_STARRED_REAL_DEVICES.FAILURE:
    case constants.UPDATE_STARRED_REAL_DEVICES.CANCEL: {
      return state.set('realDevicesStarred', undoStar(state.get('realDevicesStarred'), meta));
    }
    case constants.METADATA_PUT.SUCCESS:
      // For now we only support URL
      return (payload.url) ? state.set('url', payload.url) : state;
    default:
      return state;
  }
};

export default metadataReducer;
export { initialState };
